// tslint:disable: no-any
import thunk from "redux-thunk"
import createSagaMiddleware, { SagaMiddleware } from "redux-saga"
// eslint-disable-next-line camelcase
import jwt_decode, { JwtPayload } from "jwt-decode"
import { applyMiddleware, compose, createStore, Middleware, Store } from "redux"

import createRootReducer from "./reducers"
import AuthHelper from "../helpers/AuthHelper"

const reduxDevToolsExtensionCompose = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

const composeEnhancers: any = (window._env_.NODE_ENV === "development" && reduxDevToolsExtensionCompose ? reduxDevToolsExtensionCompose({ trace: true, traceLimit: 50 }) : null) || compose

const tokenValidatorMiddleware: Middleware = (_store) => (next) => (action) => {
  const token: string | null = AuthHelper.getToken()
  if (token) {
    const decoded: JwtPayload = jwt_decode(token)
    if (decoded.exp && decoded.exp < Date.now() / 1000) {
      AuthHelper.clearStorage()
      window.location.href = "/public/login"
      return
    }
  }
  next(action)
}
const sagaMiddleware: SagaMiddleware = createSagaMiddleware()
const middlewares: Middleware[] = [sagaMiddleware, tokenValidatorMiddleware, thunk]

export function configureStore(initialState: any): Store {
  const store: Store = createStore(createRootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)))

  if (import.meta.hot) {
    import.meta.hot.accept("./reducers", () => {
      const nextRootReducer: any = require("./reducers")
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}
